import styled from 'styled-components';

// No UI redesign (RUN.md scope guardrails): reuses the same "white card"
// look as views/Pages/Questionnaire/index.styles.tsx's PreviewBox, which is
// what AboutCompany and friends already use for a bordered content block.

// Wide enough for the readiness checklist table (RG 28.08 2.3); narrow screens
// get a tighter gutter and the table turns into a stacked list.
export const PageContainer = styled.div`
  width: 100%;
  max-width: 960px;
  padding: 40px 64px;

  @media (max-width: 599.95px) {
    padding: 24px 16px;
  }
`;

export const ActionsRow = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 8px;
`;

export const ConfirmationBox = styled.div`
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid #dddddd;
  padding: 24px;
`;
